<template>

<!-- Page length options -->
<div class="card">
    <div>
        <div v-show="onload" class="content bg-white">
            <placeholder-content isLoad="true" />
        </div>
        <div v-if="!onload && !hasPermission">
            <access-denied></access-denied>
        </div>
        <div v-else-if="!onload && !hasFeature">
            <AccessNotAvailable />
        </div>

        <div v-show="!onload && hasPermission && hasFeature" class="card-header bg-white header-elements-inline">
            <h5 class="card-title">{{ $t("Sales Report By Province") }}</h5>
        </div>
        <div v-show="!onload && hasPermission && hasFeature" class="card-body">
            <div v-show="onload">
                <div class="bg-white">
                    <placeholder-content isLoad="true" />
                </div>
            </div>

            <!-- <div class="d-flex align-items-center justify-content-start"> -->
            <div v-show="!onload">
                <div class="d-flex align-items-center justify-content-start mb-3 p-3 bg-light mt-n3 mx-n3">
                    <!-- search -->
                    <!-- <div class="toobar-search mr-3">
                        <div class="input-group bg-white">
                            <div id="product-search" class="form-group form-group-feedback form-group-feedback-right mb-0 product-search-n-1">
                            <Select2 v-model="showText" @select="productSelectEvent($event)" :settings="settingsProduct" style="min-width: 225px"/>
                            </div>
                        </div>
                    </div> -->

                    <!-- filter calendar -->
                    <span class="nowrap mr-3">{{$t("Order Date")}}</span>
                    <div class="input-group w-auto">
                        <span class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
                        </span>
                        <date-range-picker style="min-width: 175px" opens="right" :ranges="ranges" v-model="dateRange" :locale-data="localedata" :control-container-class="'form-control rounded-left-0 rounded-right-0 border-right-0'" @update="applyDatePicker">
                            <div slot="input" v-html="showTextPicker"></div>
                            <div slot="footer" slot-scope="data" class="p-2 drp-buttons">
                                <button @click="cancelDateRange()" v-if="!data.in_selection" type="button" class="applyBtn btn btn-sm btn-secondary">
                                    {{ $t("Cancel") }}
                                </button>
                                <button @click="data.clickApply" v-if="!data.in_selection" type="button" class="applyBtn btn btn-sm btn-primary">
                                    {{ $t("Apply") }}
                                </button>
                            </div>
                        </date-range-picker>

                        <button @click="openAdvanceFilter" type="button" class="btn btn-outline-normal rounded-left-0 d-flex align-items-center" data-toggle="modal" data-target="#advance_filter">
                            <i class="fas fa-sliders-v mr-2"></i>
                            <span>{{$t("More Filters")}}</span>
                            <span v-if="countFilter" class="badge badge-secondary ml-2">{{ countFilter }}</span>
                        </button>
                    </div>

                    <!-- product type -->
                    <!-- <div class="d-flex">
                        <span class="d-flex mx-3 align-items-center">{{$t("Product Type")}}</span>
                        <Select2 style="min-width: 175px" class="bg-white" v-model="paramsQuery.productTypeId" v-if="loadProductType" :options="productType" :settings="ProductTypeSetting" @change="changeProductTypeEvent($event)" />
                    </div> -->
                    <!-- perpage -->
                    <!-- <div class="dataTables_length ml-auto mb-0">
                        <PerPage @per-page="setPerPage" />
                    </div> -->
                </div>
            </div>

            <div v-if="!onload && productOnload" class="card mr-3 d-flex d-flex flex-wrap mb-3">
                <div class="media mt-2 mb-2" v-for="(p,index) in productItem" :key="index">
                    <img :src="p.image_url" class="mx-3 mr-3" style="width:100px;">
                    <div class='item-content'>
                        <div class='item-name'><span class="mr-2">{{ p.name }}</span></div>
                        <div class='item-bottom'><span class='text-muted'>SKU: {{ p.sku }}</span></div>
                    </div>
                </div>
            </div>
            <div v-if="!onload" class="d-flex d-flex flex-wrap">
                <div class="card mr-3">
                    <div class="card-body">
                        <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-sack-dollar"></i></span>
                        <h6 class="mb-0 font-weight-semibold">{{ $t("Total sales") }}</h6>
                        <h3 class="text-grey-800 font-weight-semibold my-1">฿{{totalSales.amount | formatNumber}}</h3>
                        <div v-if="totalSales.percent == '-' || totalSales.percent == 0" class="text-grey-300"><span class="mr-1">0.00%</span> {{$t('compared to last month')}}</div>
                        <div v-else class="text-grey-300">
                            <span :class="[totalSales.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[totalSales.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']"></i>{{totalSales.percent | formatNumber}}% </span> {{$t('compared to last month')}}
                        </div>
                    </div>
                </div>

                <div class="card mr-3">
                    <div class="card-body">
                        <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-shopping-cart"></i></span>
                        <h6 class="mb-0 font-weight-semibold">{{ $t("_Shipping.Number of Orders") }}</h6>
                        <h3 class="text-grey-800 font-weight-semibold my-1">{{totalOrder.amount.toFixed(0) | formatNumberDigit}}</h3>
                        <div v-if="totalOrder.percent == '-' || totalOrder.percent == 0" class="text-grey-300"><span class="mr-1">0.00%</span> {{$t('compared to last month')}}</div>
                        <div v-else class="text-grey-300">
                            <span :class="[totalOrder.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[totalOrder.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']"></i>{{totalOrder.percent | formatNumber}}% </span> {{$t('compared to last month')}}
                        </div>
                    </div>
                </div>

                <div class="card mr-3">
                    <div class="card-body">
                        <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i style="font-size: 11px;" class="fa-solid fa-box"></i></span>
                        <!-- <h6 class="mb-0 font-weight-semibold">{{ $t("Number of Products") }}</h6> -->
                        <h6 class="mb-0 font-weight-semibold">{{ $t("Sold Quantity") }}</h6>
                        <h3 class="text-grey-800 font-weight-semibold my-1">{{totalOrderQuantity.amount | formatNumberDigit}}</h3>
                        <div v-if="totalOrderQuantity.percent == '-' || totalOrderQuantity.percent == 0" class="text-grey-300"><span class="mr-1">0.00%</span> {{$t('compared to last month')}}</div>
                        <div v-else class="text-grey-300">
                            <span :class="[totalOrderQuantity.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[totalOrderQuantity.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']"></i>{{totalOrderQuantity.percent | formatNumber}}% </span> {{$t('compared to last month')}}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!onload" class="d-flex d-flex flex-wrap mb-3">
                <div v-if="checkEvent"></div>
                <gmap-map :center="center" :zoom="7" style="width:100%;  height: 600px;">
                    <gmap-marker :key="index" v-for="(m,index) in locations" :position="{ lat: parseFloat(m.lat), lng: parseFloat(m.lng) }" :clickable="true" :draggable="true" @click="openMarker(m.id)">
                        <gmap-info-window :options="{ pixelOffset: { width: 0, height: 30 } }"
                        :position="{ lat: parseFloat(m.lat), lng: parseFloat(m.lng) }"
                        :opened="m.isOpen"
                        :closeclick="true"
                        @closeclick="closeMarker(m.id)">
                        <span>{{m.province}}</span><br><span>฿{{m.total|formatNumber}}</span></gmap-info-window>
                    </gmap-marker>
                </gmap-map>
            </div>
            <div class="card" v-show="!onload">
                <div :class="['table-responsive mt-0 data-nowrap table-hover table-order']" id="table-order">
                    <div class="vuetable-wrapper datatable-scroll">
                        <vuetable :class="[loadingTable]" ref="vuetable" class="overflow-x-auto" :no-data-template="$t('No Data Available')" :fields="table.fields" data-path="data" pagination-path="" :api-mode="false" :data-manager="dataManager" @vuetable:loaded="vuetableLoaded" @vuetable:loading="vuetableLoading" @vuetable:pagination-data="onPaginationData" :sort-order="sortOrder">
                            <template slot="tableFooter">
                                <tr>
                                  <th
                                    v-for="(field, indexField) in dataFooterFields"
                                    :class="field.dataClass"
                                    class="position-relative"
                                    :key="indexField + '_' + field.visible"
                                  >
                                      <template v-if="field.name == 'state'">
                                        <span>
                                          {{ $t("Total") }}
                                        </span>
                                      </template>
                                      <template v-else-if="field.name == 'count_order'">
                                        {{ totalOrders | formatNumberNotZero }}
                                      </template>
                                      <template v-else-if="field.name == 'order_quantity'">
                                        {{ totalqty | formatNumberNotZero }}
                                      </template>
                                      <template v-else-if="field.name == 'total'">
                                        {{ totalSale | formatNumber }}
                                      </template>
                                  </th>
                                </tr>
                              </template>
                        </vuetable>
                    </div>
                    <div class="datatable-footer">
                        <vuetable-pagination-info class="dataTables_info ml-3" ref="paginationInfo" :no-data-template="$t('No relevant data')" :info-template="$t('Displaying {from} to {to} of {total} items')"></vuetable-pagination-info>
                        <div class="dataTables_paginate paging_simple_numbers mb-0 mr-2">
                            <vuetable-pagination ref="pagination" pagination-path="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <advance-filter v-if="isadvanceFilter"></advance-filter>
</div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import DateRangePicker from "vue2-daterange-picker";
import PerPage from "../PerPage.vue";
import Select2 from "v-select2-component";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
import fields from "../assets/js/SalesByProvince_fields.js";
import {
    showTextPicker,
} from "../assets/directives/Vuetable.js";
import moment from "moment";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone";
import numeral from "numeral";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import SubscriptionExpired from "@/components/tenancy/admin/error-page/templates/SubscriptionExpired.vue";
import Province from "./Province.json";
import Cookies from 'js-cookie';
import AccessNotAvailable from "../../error-page/templates/AccessNotAvailable.vue";
import AdvanceFilter from './AdvanceFilterByProvince.vue';

export default {
    components: {
        DateRangePicker,
        PerPage,
        Select2,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PlaceholderContent,
        AccessDenied,
        SubscriptionExpired,
        AccessNotAvailable,
        AdvanceFilter,
    },
    data() {
        var self = this;
        return {
            hasFeature: true,
            checkedCount: 0,
            defaultStartDate: moment().subtract(1, 'months').format('YYYY-MM-DD 17:00:00'),
            defaultEndDate: moment().format('YYYY-MM-DD 16:59:59'),
            table: {
                fields: fields,
            },
            showbigimage: '',
            sortOrder: [
                {
                field: "total",
                direction: "DESC"
                }
            ],
            paramsQuery: {
                start_date: this.$route.query.start_date != undefined ? this.$route.query.start_date : moment().subtract(1, 'months').format('YYYY-MM-DD'),
                end_date: this.$route.query.end_date != undefined ? this.$route.query.end_date : moment().format('YYYY-MM-DD'),
                productTypeId: 'all',
                per_page: 10,
                current_page: 1,
                // sort: '',
                page: 1,
                order_status: ["pending", "processing", "completed"],
            },
            dateRange: {
                startDate: this.defaultStartDate,
                endDate: this.defaultEndDate,
            },
            showText: '',
            productType: [],
            ProductTypeSetting: {
                minimumResultsForSearch: Infinity,
                placeholder: this.$t("Product Type") + "..",
            },
            loadProductType: false,
            loadPerspective: false,
            onload: true,
            hasPermission: true,
            ranges: this.$storeIndex.ranges(),
            localedata: {
                format: 'DD-MM-YYYY',
                applyLabel: this.$t('Apply'),
                cancelLabel: this.$t('Cancel'),
                clearable: true,
                monthNames: this.$storeIndex.monthNames(),
                daysOfWeek: this.$storeIndex.daysOfWeek(),
            },
            dateTxtFilter: null,
            loadingTable: null,
            i: 0,
            totalSales: {
                amount: 0,
                percent: 0
            },
            totalOrderQuantity: {
                amount: 0,
                percent: 0
            },
            totalOrder: {
                amount: 0,
                percent: 0
            },
            feedLoaded: false,
            options: {
                mapTypeControl: false,
                streetViewControl: false
            },
            center: { lat: 13.72456, lng: 100.4930241 },
            info_marker: null,
            infowindow: {lat: 13.72456, lng: 100.4930241},
            checkEvent: true,
            infoOptions: {
                content: '',
                //optional: offset infowindow so it visually sits nicely on top of our marker
                pixelOffset: {
                width: 0,
                height: 30
                }
            },
            openMarkerId: null,
            infoWindowPos: null,
            infoWinOpen: true,
            currentMidx: null,
            productOnload: false,
            settingsProduct: {
                language: {
                    noResults: this.noResults,
                },
                placeholder: this.$t('Please Select Product')+'...',
                multiple: true,
                ajax: {
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", 'Bearer ' + Api.AUTH.TOKEN);
                    },
                    url: Api.AUTH.URL + Api.URL.ORDER_GETPRODUCT,
                    data: function (params) {
                        let queryProductTypeId = '1,3';//all
                        switch (self.paramsQuery.productTypeId) {
                            case '1':
                            case '2':
                                queryProductTypeId = '1';//not show product config
                                break;
                            case '3':
                                queryProductTypeId = self.paramsQuery.productTypeId;
                                break;
                        }

                        var query = {
                            q: params.term,
                            publish: '1',
                            product_type_id: queryProductTypeId,
                            show_variant:1,
                        }
                        return query;
                    },
                    processResults: function (data) {
                        let product = data.data;
                        return {
                            results: product
                        }
                    }
                },
                templateResult: this.templateProduct,
                templateSelection: this.templateCustomSelect,
                escapeMarkup: function (m) {
                    return m;
                },
                allowClear: false,
            },
            isadvanceFilter: false,
            countFilter: 0,
            dataFooterFields: [],
            vuetableFields: false,
            dataTable: [],
            filterData: null,
            statusList: [],
        };
    },
    computed: {
        showTextPicker: function () {
            if (this.dateRange.startDate && this.dateRange.endDate) {
                this.dateRange.startDate = convertTimezone.utcToLocal(this.dateRange.startDate);
                this.dateRange.endDate = convertTimezone.utcToLocal(this.dateRange.endDate);
                this.dateTxtFilter = showTextPicker(this.dateRange);
                return this.dateTxtFilter;
            } else {
                return showTextPicker(this.paramsQuery);
            }
        },
        totalOrders() {
            let dataTable = this.dataTable.data;
            if (dataTable && dataTable.length > 0) {
                let totalData = dataTable.map((item) => {
                    return parseFloat(item.count_order);
                });

                return totalData.reduce((total, item) => total + item, 0);
            } else {
                return 0;
            }
        },
        totalqty() {
            let dataTable = this.dataTable.data;
            if (dataTable && dataTable.length > 0) {
                let totalData = dataTable.map((item) => {
                    return parseFloat(item.order_quantity);
                });

                return totalData.reduce((total, item) => total + item, 0);
            } else {
                return 0;
            }
        },
        totalSale() {
            let dataTable = this.dataTable.data;
            if (dataTable && dataTable.length > 0) {
                let totalData = dataTable.map((item) => {
                    return parseFloat(item.total);
                });

                return totalData.reduce((total, item) => total + item, 0);
            } else {
                return 0;
            }
        },
        footerTableFields() {
            if (this.vuetableFields !== false) {
                return this.$refs.vuetable.tableFields;
            } else {
                return [];
            }
        },
    },
    watch: {
        footerTableFields: {
            handler: function (nval, oval) {
                let newFooterTableArray = [];
                nval.forEach((element) => {
                    if (element.visible === true) {
                        newFooterTableArray.push(element);
                    }
                });
                this.$nextTick(() => {
                    this.dataFooterFields = newFooterTableArray;
                });
            },
            deep: true,
        },
    },
    methods: {
        openMarker(id){
            let index = this.locations.findIndex(l => l.id == id);
            this.locations[index].isOpen = false;
            this.checkEvent = false;
            this.$nextTick(() => {
                    this.locations[index].isOpen = true;
                    this.checkEvent = true;
            });
        },
        closeMarker(id){
            let index = this.locations.findIndex(l => l.id == id);
            this.locations[index].isOpen = true;
            this.checkEvent = true;
            this.$nextTick(() => {
                    this.locations[index].isOpen = false;
                    this.checkEvent = false;
            });
        },
        dataManager(sortOrder, pagination) {
            if (sortOrder.length > 0) {
                this.paramsQuery.sort = sortOrder.map((item) => `${item.sortField}|${item.direction}`).join(',')
            }
            this.setParams();
        },
        onPaginationData(tablePagination) {
            this.$refs.paginationInfo.setPaginationData(tablePagination);
            this.$refs.pagination.setPaginationData(tablePagination);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        search() {
            this.setParams();
        },
        changeProductTypeEvent(val) {
            this.setParams();
        },
        setPerPage(perPage) {
            this.paramsQuery.current_page = 1;
            this.$refs.vuetable.currentPage = 1;
            this.paramsQuery.per_page = perPage;
            this.setParams();
        },
        vuetableLoaded() {
            // this.onload = false;
        },
        vuetableLoading() {},
        cancelDateRange() {
            // this.paramsQuery.start_date = this.defaultStartDate;
            // this.paramsQuery.end_date = this.defaultEndDate;
            $(".daterangepicker").remove();
            this.setParams();
        },
        applyDatePicker(dateRange) {
            // console.log("dateRange: ", dateRange);
            // console.log("query: ", moment(dateRange.startDate).format('YYYY-MM-DD'), moment(dateRange.endDate).format('YYYY-MM-DD'));
            this.paramsQuery.productTypeId = 'all';
            this.paramsQuery.per_page = 10;
            this.paramsQuery.current_page = 1;
            this.$refs.vuetable.currentPage = 1;
            this.paramsQuery.page = 1;
            this.paramsQuery.start_date = dateRange.startDate;
            this.paramsQuery.end_date = dateRange.endDate;
            this.$router.replace({query: {
              start_date: moment(dateRange.startDate).format('YYYY-MM-DD'),
              end_date: moment(dateRange.endDate).format('YYYY-MM-DD'),
          }}).catch(()=>{})
            this.setParams();
        },
        showimage(data) {
            this.showbigimage = data;
        },
        async setParams() {
            try {
                // if (this.i++ > 0) {
                    // this.loadingTable = "loading";
                    this.onload = true;
                // }

                this.paramsQuery.start_date = convertTimezone.localToUtc(moment(this.paramsQuery.start_date).startOf('day'), false).format('YYYY-MM-DD HH:mm:ss');
                this.paramsQuery.end_date = convertTimezone.localToUtc(moment(this.paramsQuery.end_date).endOf('day'), false).format('YYYY-MM-DD HH:mm:ss');
                this.paramsQuery.page = this.$refs.vuetable.currentPage;
                let queryString = "";
                if (this.paramsQuery) {
                    queryString += "?" + $.param(this.paramsQuery);
                }
                // this.setQuerystring(this.paramsQuery);

                // let dataSales = this.$storeIndex.mutations.vueTableFormatJson(
                //     await Api.Report.getSalesReportByProvinceTable(queryString)
                // );
                // console.log('data:' , data);
                let data = await Api.Report.getSalesReportByProvince(queryString);
                if(data.status == 403){
                    this.onload = false;
                    if(data.hasOwnProperty('data')&&(data.data.message == "You can not active plan feature report-sales-by-province")){
                        this.hasFeature = false;
                        return;
                    }
                    this.hasPermission = false;
                    return;
                }
                this.totalSales = data.data.totalSales;
                this.totalOrderQuantity = data.data.totalOrderQuantity;
                this.totalOrder = data.data.totalOrder;
                this.getProduct(data.data.product);

                this.filterData = data && data.data && data.data.filter ? data.data.filter : null;
                if (this.filterData && this.filterData.order_status && this.filterData.order_status.length) {
                    this.statusList = [];
                    this.filterData.order_status.map(el => {
                    this.statusList.push({
                        id: el,
                        icon: el == "pending" ? '<i class="fa-solid fa-clock"></i>' :
                            el == "processing" ? '<i class="fas fa-sync-alt"></i>' :
                            el == "completed" ? '<i class="fas fa-check-circle"></i>' :
                            el == "returned" ? '<i class="fa-solid fa-arrow-rotate-left"></i>' :
                            '<i class="fas fa-times-square"></i>',
                        name: el == "pending" ? "_Shipment.Pending" : 
                            el == "processing" ? "Processing" :
                            el == "completed" ? "Completed" :
                            el == "returned" ? "_Order.Returned" :
                            "Cancel",
                    })
                    })
                }
                // let dataSales = this.$storeIndex.mutations.vueTableFormatJson(
                    let dataSales = await Api.Report.getSalesReportByProvinceTable(queryString)
                // );
                this.$refs.vuetable.setData(dataSales.data);
                this.dataTable = dataSales.data;
                this.dataSalesMap = dataSales.data.data;
                this.location = Province;
                this.locations = [];
                for (let data of this.dataSalesMap) {
                    let index = this.location.findIndex(l => l.province == data.state);
                    // console.log('data:',this.location[index]);
                    if(!this.location[index]) continue;
                    this.locations.push({
                        lat: this.location[index].lat,
                        lng: this.location[index].lng,
                        total: data.total,
                        province: data.state,
                        id: this.location[index].id,
                        isOpen: true
                    });
                    this.feedLoaded = true;
                }
                this.loadingTable = "";
                // this.hasPermission = false;
                this.onload = false;

                this.vuetableFields = this.$refs.vuetable.tableFields.filter((field) => field.togglable);
            }
            catch (error) {
                console.log(error, 'error');
                
            }
        },
        setQuerystring(obj) {
            this.$router.push({
                query: Object.assign({}, this.$route.query, obj)
            }).catch(() => {});
        },
        toggleInfoWindow: function(marker, idx) {
            this.infoWindowPos = { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) };
            this.infoOptions.content = 'marker.infoText';

            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;
            }
        },
        getProduct(d){
            this.dataProduct = d;
            // console.log('data: ',this.dataProduct);
            this.productItem = [];
            if(d != ''){
                for (let data of this.dataProduct) {
                    console.log('data: ',data);
                    let image = '';
                    if(data.product_media_first == null){
                        image = require("@/assets/images/no-image-2.png");
                    } else {
                        image = data.product_media_first.media.image_url;
                    }
                    // console.log('image: ',image)
                    this.productItem.push({
                        name: data.name,
                        sku: data.sku,
                        image_url: image,
                    });

                }
                this.productOnload = true;
            }
            // console.log('this.productItem',this.productItem)
        },
        productSelectEvent(e){
            this.paramsQuery.search = e.id;
            this.showText = e.name;
            this.setParams();
            console.log('data:',this.showText);
        },
        noResults() {
            return this.$t('No Result Found');
        },
        templateProduct(e) {
            let option = "";
            if (e.text == "Searching…") {
                option = this.$t("Searching...");
            } else {
                var image = '<img class="rounded mr-3" src="'+ this.$storeIndex.getImageSrc('channel/none') +'" style="width: 50px;">';
                if (this.$storeIndex.isset(() => e.product_media_first.media.image_url)) {
                    image = '<img class="rounded mr-3" src="'+ (this.$storeIndex.isset(() => e.product_media_first.media.image_url) ? e.product_media_first.media.image_url : '') +'" style="width: 50px;">';
                }
                option = "<div class='d-flex align-items-center'>";
                option += "<div class='item-image ml-1'>" + image + "</div><div class='item-content w-75'>";
                option += "<div class='font-weight-semibold item-name '>" + e.name + "</div><div class='item-bottom'><span>SKU:" + e.sku + "</span></div>";
                option += "</div>";
                option += "<div class='align-self-lg-stretch item-right text-right w-25'>";
                option += "</div>";
                option += "</div>";
            }
            return option;
        },
        templateCustomSelect(e) {
            return e.name;
        },
        openAdvanceFilter() {
            this.isadvanceFilter = true;
            this.$nextTick(() => {
                this.isadvanceFilter = true
            });
        },
        filterinfo(data) {
            this.paramsQuery.order_status = data.order_status;
            this.paramsQuery.payment_method_ids = data.payment_method;
            this.paramsQuery.payment_status = data.payment_status;
            this.setParams();
        },
    },
    async mounted() {
        // this.$router.replace({query: {
        //     start_date: convertTimezone.utcToLocal(moment(this.paramsQuery.start_date), false).format('YYYY-MM-DD'),
        //     end_date: convertTimezone.utcToLocal(moment(this.paramsQuery.end_date), false).format('YYYY-MM-DD'),
        // }}).catch(()=>{})
        this.dateRange.startDate = this.paramsQuery.start_date = this.$route.query.start_date ? this.$route.query.start_date : this.defaultStartDate;
        this.dateRange.endDate = this.paramsQuery.end_date = this.$route.query.end_date ? this.$route.query.end_date : this.defaultEndDate;
        this.onload = true;
        let i = 0;
        let publishProductType = ['Simple', 'Config', 'Set'];
        const productType = await Api.ProductType.getProductType();
        this.productType[i] = {
            text: this.$t('All'),
            id: 'all',
        };
        await productType.data.data.forEach((data, key) => {
            if (publishProductType.includes(data.name)) {
                this.productType[++i] = {
                    text: (data.name == 'Set') ? this.$t("Product " + data.name) : this.$t(data.name + " Product"),
                    id: data.id,
                };
            }
        });
        this.loadProductType = true;
        this.loadPerspective = true;
        // this.setParams();
        this.countFilter =
            (this.paramsQuery.payment_method_ids && this.paramsQuery.payment_method_ids.length == undefined ? 1 : 0) +
            (this.paramsQuery.payment_status && typeof this.paramsQuery.payment_status == "string" ? 1 : 0) +
            (this.paramsQuery.order_status.length ? 1 : 0);

    },
    filters: {
        formatNumberDigit: function (value) {
            return numeral(value).format("0,0");
        },
        formatNumber: function (value) {
            if (value == '-') {
                value = 0;
            }
            return numeral(value).format("0,0.00");
        },
        formatNumberNotZero: function (value) {
            return numeral(value).format("0,0");
        },
    },
};

</script>




<style >
.product-search-n-1 .select2-container--default .select2-selection--multiple .select2-search--inline .select2-search__field {
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/SalesByProvince.vue